import Brochure from './brochure'

export default Brochure
